import React, { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './admin.css';

/**
 * Auth + role gate for /admin. Non-admins get bounced to login or home.
 * CRM-only users (Admin=false, CRM=true) see only the "Lead-uri" tab and
 * are redirected away from Users / Overview / Audit if they try to land
 * on those routes directly.
 */
const AdminLayout = () => {
  const { isAuthenticated, isAdmin, isCRM, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // CRM-only users may only reach /admin/leads. Any other /admin/* path
  // gets a 1-shot redirect so a deep link still lands somewhere usable.
  useEffect(() => {
    if (loading || !isAuthenticated) return;
    if (!isAdmin && isCRM && !location.pathname.startsWith('/admin/leads')) {
      navigate('/admin/leads', { replace: true });
    }
  }, [loading, isAuthenticated, isAdmin, isCRM, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="admin-shell">
        <div className="admin-loading">Se incarca…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    navigate('/login?redirect=/admin', { replace: true });
    return null;
  }

  if (!isAdmin && !isCRM) {
    return (
      <div className="admin-shell">
        <div className="admin-denied">
          <h2>Acces restricționat</h2>
          <p>
            Această secțiune este disponibilă doar pentru utilizatorii cu rolul
            Admin sau CRM.
          </p>
          <Link to="/" className="admin-link">
            Înapoi la pagina principală
          </Link>
        </div>
      </div>
    );
  }

  const navItem = ({ isActive }) =>
    `admin-nav-link${isActive ? ' is-active' : ''}`;

  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="admin-header-inner">
          <h1>Dashboard admin</h1>
          <nav className="admin-nav">
            {isAdmin && (
              <NavLink to="/admin" end className={navItem}>
                Overview
              </NavLink>
            )}
            {isAdmin && (
              <NavLink to="/admin/users" className={navItem}>
                Users
              </NavLink>
            )}
            <NavLink to="/admin/leads" className={navItem}>
              Lead-uri (invitații)
            </NavLink>
            {isAdmin && (
              <NavLink to="/admin/audit" className={navItem}>
                Audit
              </NavLink>
            )}
          </nav>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
